import React from "react";
import { Combo } from "../../common/components/comboBox";
import { CaldaiaDto } from "../../generated";
import { formGroup } from "../../common/components/formGroup";
import { CaldaieByMarcaStore } from "../caldaieStore";
import { Loading } from "../../common/components/loading";

const Combobox = Combo<CaldaiaDto>();
interface Props {
    marca: string;
    value: number | null,
    onChange: (type: CaldaiaDto | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
const __CaldaiaSelector = ({ onChange, value, error, label, onBlur, onFocus, marca }: Props) => {
    const data = CaldaieByMarcaStore.useMarca(marca);
    if (!data)
        return <Loading />
    return <Combobox
        label={label ?? "Caldaia"}
        allowNull
        data={data.filter(caldaia => caldaia.marcaCaldaia == marca)}
        textField={x => x.modelloCaldaia ?? ""}
        onSelect={x => onChange(x ?? null)}
        value={data.find(caldaia => caldaia.idCaldaia == value) ?? null}
        error={error}
        onBlur={onBlur}
        onFocus={onFocus}
    />;
}
export const CaldaiaSelector = formGroup(__CaldaiaSelector);